import React from 'react'
import '../../dist/loadmore.css'

const Loadmore = () => {
  return (
    <div className="container flex justify-center items-center w-full h-full">
        <div className="loader"></div>
    </div>
  )
}

export default Loadmore